export const getFillColor = (fCValue, theme) => {
  if (fCValue === 'true') return theme.colorBrightGreen500 ?? '#34C38F'
  if (fCValue === 'false') return theme.colorBrightRed500 ?? '#CD0204'
  return theme.colorBrightYellow500 ?? '#F1B44C'
}
